import { useEffect, useState, useRef } from 'react';
import { Form, Table, Button, Tooltip, Input, Upload } from 'antd';
import { useTranslation } from 'react-i18next';
import DataBreachService from '../../../../../services/DataBreach.service';
import useNotify from '../../../../../context/Notification/useNotify';
import IconNotFound from '../../../../../assets/Images/icons/empty';
import { UploadOutlined } from '@ant-design/icons';
import GlobalService from '../../../../../services/Global.service';

export default function Tab5Component({ details, permission, status }) {
    const { t, i18n } = useTranslation('data-breach');
    const notify = useNotify();
    const [form] = Form.useForm();

    const [docId, setDocId] = useState(null);
    const [currentPage, setCurrentPage] = useState({
        tDataBreachId: details,
        sd: 'fileName',
        s: 'asc',
    });

    const [documentData, setDocumentData] = useState([]);
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [renameId, setRenameId] = useState(null);
    const [loadinSave, setLoadinSave] = useState(false);
    const [isRenaming, setIsRenaming] = useState(false);
    const [uploading, setUploading] = useState(false);

    const tooltipRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
                setOpenConfirmDelete(false);
                setDocId(null);
            }
        };
        if (openConfirmDelete) {
            document.addEventListener("mousedown", handleClickOutside);
        } 
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openConfirmDelete]);

    useEffect(() => {
        getDocumentList(currentPage);
    }, []);

    const getDocumentList = (pageValue) => {

        const payload = {
            sd: pageValue.sortBy || 'fileName',
            s: pageValue.sortDirection || 'asc',
            tDataBreachId: details,
        };
        DataBreachService.getDocumentList(payload).then((res) => {
            setDocumentData(res?.data?.resultData || []);
        });
    };

    const handleDelete = async (id) => {
        await setDocId(id);
        await deleteAction(id)
    }
    const deleteAction = async (id) => {
        await DataBreachService.deleteDocument(id)
            .then((res) => {
                setOpenConfirmDelete(false);
                setDocId(null);
                getDocumentList(currentPage);
                
                setTimeout(() => {
                    setDocId(null);
                    setOpenConfirmDelete(false);
                }, 100);
            })
            .catch((err) => {
                setOpenConfirmDelete(false);
                setDocId(null);
            });
    };

    const hoverDescription = async (action) => {
        if(!openConfirmDelete) {
            setDocId(action)
        } else {
            await setDocId(null)
            await setOpenConfirmDelete(false);
            setDocId(action)
        }
        
    };

    const editDescription = (id) => {
        const selectedDocument = documentData.find((doc) => doc.documentId === id);

        if (selectedDocument) {
            form.setFieldsValue({
                description: selectedDocument.description,
            });
            setIsEditing(true);
            setRenameId(id);
        }
    };

    const cancelRename = () => {
        setIsEditing(false);
        setRenameId(null);
        setIsRenaming(false);
    };

    const onSave = async (values) => {
        if (isRenaming) {
            const payload = {
                documentId: renameId,
                description: values.description,
            };
            DataBreachService.renameDataBreachDescription(payload)
                .then((res) => {
                    setLoadinSave(false);
                    cancelRename();
                    getDocumentList(currentPage);
                })
                .catch((err) => {
                    notify({
                        type: 'error',
                        title: t('Fail'),
                        description: t('FailedtoSubmitData'),
                        closeable: true,
                        timeOut: 120000,
                    });
                    setLoadinSave(false);
                });
        }
    };

    const convertBase64toBlob = (content, contentType) => {
        contentType = contentType || '';
        const sliceSize = 512;
        const byteCharacters = window.atob(content); //method which converts base64 to binary
        const byteArrays = [];
        for (
            let offset = 0;
            offset < byteCharacters.length;
            offset += sliceSize
        ) {
            let slice = byteCharacters.slice(offset, offset + sliceSize);
            let byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            let byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        let blob = new Blob(byteArrays, {
            type: contentType,
        });
        return blob;
    };

    const download = async (id, fileName) => {
        try {
            const res = await GlobalService.getImage(id);
            if (res.data.resultData && res.data.resultData.fileType) {
                const mimeType = res.data.resultData.fileType;
                const bis = res.data.resultData.imageId;
                const extension = mimeType === "application/octet-stream" ? 'pdf' : mimeType.split('/')[1]; // Extract the file extension
                const fileBlob = convertBase64toBlob(bis, mimeType);
                // Create a download link
                let link = document.createElement('a');
                link.download = `${fileName}.${extension}`;
                link.href = URL.createObjectURL(fileBlob);
                link.click();
                link.remove();
            } else {
                console.error("Invalid response data or missing mimeType.");
            }
        } catch (error) {
            console.log(error);
        }
    };
    const view = async (id) => {
        try {
            const res = await GlobalService.getImage(id);

            if (res.data.resultData && res.data.resultData.fileType && res.data.resultData.imageId) {
                const { fileType, imageId, fileName } = res.data.resultData;
                const newType = fileType === 'application/octet-stream' ? 'application/pdf' : fileType
                // Assuming the imageId is base64 encoded data
                const fileBlob = new Blob([new Uint8Array(atob(imageId).split("").map(char => char.charCodeAt(0)))], { type: newType });
                const fileUrl = URL.createObjectURL(fileBlob);

                if (newType.startsWith("image/")) {
                    // If it's an image, open it in a new tab
                    window.open(fileUrl, "_blank");
                } else if (newType === "application/pdf") {
                    // If it's a PDF, open it in a new tab
                    window.open(fileUrl, "_blank");
                } else {
                    console.error("Unsupported file type:", newType);
                }
            } else {
                console.error("Invalid response data or missing fileType/imageId.");
            }
        } catch (error) {
            console.error("Error fetching or viewing file:", error);
        }
    };

    const columns = [
        {
            title: t('File Name'),
            dataIndex: 'fileName',
            key: 'fileName',
            sorter: true,
            render: (value, record) => {
                return (
                    <div className="space-y-1">
                        <div className="text-[#1E1E1E] font-normal text-sm">{record.fileName}</div>
                    </div>
                );
            },
        },
        {
            title: t('Description'),
            dataIndex: 'description',
            key: 'description',
            sorter: true,
            render: (value, record) => {
                return (
                    <div className="space-y-1">
                        {isEditing && renameId === record.documentId ?
                            <Form
                                scrollToFirstError={{
                                    behavior: 'smooth',
                                    block: 'center',
                                }}
                                onFinish={onSave}
                                form={form}
                                className="w-full"
                                layout="vertical"
                                onFieldsChange={(_, allFields) => {
                                    if (allFields.length > 0) {
                                        setIsRenaming(true);
                                    }
                                }}
                            >
                                <div className='flex gap-2'>
                                    <Form.Item
                                        label={false}
                                        name="description"
                                        className='mb-0 w-full pt-2'
                                    >
                                        <Input
                                            size="large"
                                            showCount
                                            maxLength={100}
                                        />
                                    </Form.Item>
                                    <div className='flex items-center rename-butt'>
                                        <button
                                            loading={loadinSave}
                                            disabled={!isRenaming}
                                            htmlType="submit"
                                            className={`text-blue-400 hover:opacity-80 font-semibold ${isRenaming ? 'cursor-pointer' : 'cursor-not-allowed'
                                                }`}
                                        >
                                            {t('Save')}
                                        </button>
                                        <span className='flex items-center text-[#95A0A8] font-semibold pl-2 cursor-pointer hover:text-[#ff4d4f]' onClick={() => cancelRename()}>{t('Cancel')}</span>

                                    </div>
                                </div>

                            </Form>
                            :
                            <Tooltip
                                placement="left"
                                title={t('Click to Edit')}
                                className="cursor-pointer hover:opacity-80"
                                open={permission.viewEdit && record.documentId === docId && !openConfirmDelete}
                            >
                                <div
                                    key={record.documentId}
                                    className="text-[#1E1E1E] font-normal text-sm"
                                    onClick={permission.viewEdit && record.documentId === docId ? () => editDescription(record.documentId) : null}
                                    onMouseEnter={() => hoverDescription(record.documentId)}
                                    onMouseLeave={() => setDocId(null)} >{record.description}
                                </div>
                            </Tooltip>
                        }

                    </div>
                );
            },
        },
        {
            title: t('Edit action'),
            key: 'action',
            align: 'center',
            width: 200,
            render: (text, record) => (
                status === 'Under Management' &&
                <span className="space-x-2">
                    <Tooltip
                        placement="bottom"
                        title={t('View')}
                        className="cursor-pointer hover:opacity-80"
                        onClick={() => view(record.fileStorageId, record.fileName)}
                    >
                        <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.5" width="32" height="32" rx="6" fill="#F3F6F9" />
                            <path d="M16.5 18C17.6046 18 18.5 17.1046 18.5 16C18.5 14.8954 17.6046 14 16.5 14C15.3954 14 14.5 14.8954 14.5 16C14.5 17.1046 15.3954 18 16.5 18Z" fill="#7B67FB" />
                            <path d="M23.97 15.83C23.382 14.3088 22.361 12.9933 21.0334 12.046C19.7058 11.0988 18.1298 10.5613 16.5 10.5C14.8703 10.5613 13.2942 11.0988 11.9666 12.046C10.639 12.9933 9.61811 14.3088 9.03003 15.83C8.99032 15.9399 8.99032 16.0601 9.03003 16.17C9.61811 17.6912 10.639 19.0067 11.9666 19.954C13.2942 20.9012 14.8703 21.4387 16.5 21.5C18.1298 21.4387 19.7058 20.9012 21.0334 19.954C22.361 19.0067 23.382 17.6912 23.97 16.17C24.0097 16.0601 24.0097 15.9399 23.97 15.83ZM16.5 19.25C15.8572 19.25 15.2289 19.0594 14.6944 18.7023C14.16 18.3452 13.7434 17.8376 13.4974 17.2437C13.2514 16.6499 13.1871 15.9964 13.3125 15.366C13.4379 14.7355 13.7474 14.1564 14.2019 13.7019C14.6565 13.2474 15.2355 12.9378 15.866 12.8124C16.4964 12.687 17.1499 12.7514 17.7438 12.9974C18.3376 13.2434 18.8452 13.6599 19.2023 14.1944C19.5594 14.7289 19.75 15.3572 19.75 16C19.7487 16.8615 19.4059 17.6874 18.7967 18.2966C18.1875 18.9058 17.3616 19.2487 16.5 19.25Z" fill="#7B67FB" />
                        </svg>
                    </Tooltip>
                    {permission.viewEdit &&
                        <>
                            <Tooltip
                                placement="bottom"
                                title={t('Download')}
                                className="cursor-pointer hover:opacity-80"
                                onClick={() => download(record.fileStorageId, record.fileName)}
                            >
                                <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect x="0.5" width="32" height="32" rx="6" fill="#F3F6F9" />
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.1666 16.784L19.3286 14.6227L20.2713 15.5653L16.5 19.3367L12.7286 15.5653L13.6713 14.6227L15.8333 16.784V9.33398H17.1666V16.784ZM11.1666 18.6673H12.5V21.334H20.5V18.6673H21.8333V21.334C21.8333 22.0673 21.2333 22.6673 20.5 22.6673H12.5C11.7666 22.6673 11.1666 22.0253 11.1666 21.334V18.6673Z" fill="#7B67FB" />
                                </svg>
                            </Tooltip>
                            <Tooltip
                                placement="bottom"
                                title={t('Delete')}
                                className="cursor-pointer hover:opacity-80"
                            >
                                {/* <Tooltip
                                    title={<div>
                                        <h5 className='font-semibold text-base'>{t('Confirm Deletion')}</h5><p className='mb-0 text-gray-dark'>{t('Confirm Deletion file Text')}</p><hr className='border-b border-solid border-[#ECECEC]'></hr>
                                        <div className='flex gap-1'>
                                            <Button onClick={handleCancel} type='primary' size='small' ghost className='w-36 h-8' htmlType='button'>{t('Cancel')}</Button>
                                            <Button onClick={() => handleDelete(record.documentId)} type='primary' size='small' className='w-36 h-8 bg-[#F0536F] border-[#F0536F] text-white hover:bg-[#F0536F] hover:border-[#F0536F] hover:text-white' htmlType='button'>{t('Confirm')}</Button>
                                        </div>
                                    </div>}
                                    placement="left" color="white" key={record.documentId} open={openConfirmDelete && docId === record.documentId}>
                                    {!permission.viewOnly ?
                                        <svg
                                            onClick={() => {
                                                setOpenConfirmDelete(true);
                                                setDocId(record.documentId);
                                            }}
                                            width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect width="32" height="32" rx="6" fill="#F3F6F9" />
                                            <path d="M15.9998 9C16.5487 8.99992 17.0778 9.20504 17.4832 9.57509C17.8887 9.94513 18.1411 10.4534 18.191 11H21.5998C21.7518 11 21.8982 11.0578 22.0092 11.1616C22.1203 11.2654 22.1879 11.4074 22.1982 11.5591C22.2086 11.7108 22.161 11.8607 22.0651 11.9786C21.9691 12.0966 21.832 12.1737 21.6814 12.1944L21.5998 12.2H21.1334L20.1198 20.984C20.0747 21.3739 19.8878 21.7336 19.5947 21.9947C19.3016 22.2558 18.9227 22.4001 18.5302 22.4H13.4694C13.0769 22.4001 12.698 22.2558 12.4049 21.9947C12.1118 21.7336 11.9249 21.3739 11.8798 20.984L10.8654 12.2H10.3998C10.2548 12.2 10.1147 12.1475 10.0055 12.0522C9.89619 11.9569 9.82512 11.8252 9.8054 11.6816L9.7998 11.6C9.79981 11.455 9.85232 11.3149 9.94762 11.2057C10.0429 11.0964 10.1746 11.0253 10.3182 11.0056L10.3998 11H13.8086C13.8585 10.4534 14.1109 9.94513 14.5164 9.57509C14.9218 9.20504 15.4509 8.99992 15.9998 9ZM14.7998 14C14.6038 14 14.4398 14.124 14.4062 14.2872L14.3998 14.3504V19.2504L14.4062 19.3128C14.4398 19.476 14.6038 19.6 14.7998 19.6C14.9958 19.6 15.1598 19.476 15.1934 19.3128L15.1998 19.2496V14.3512L15.1934 14.2872C15.1598 14.1248 14.9958 14 14.7998 14ZM17.1998 14C17.0038 14 16.8398 14.124 16.8062 14.2872L16.7998 14.3504V19.2504L16.8062 19.3128C16.8398 19.476 17.0038 19.6 17.1998 19.6C17.3958 19.6 17.5598 19.476 17.5934 19.3128L17.5998 19.2496V14.3512L17.5934 14.2872C17.5598 14.1248 17.3958 14 17.1998 14ZM15.9998 10.2C15.5158 10.2 15.1118 10.544 15.0198 11H16.9798C16.887 10.544 16.4838 10.2 15.9998 10.2Z" fill="#7B67FB" />
                                        </svg>
                                        :
                                        <svg className='cursor-not-allowed' width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <rect width="32" height="32" rx="6" fill="#F2F2F2" />
                                            <path d="M15.9998 9C16.5487 8.99992 17.0778 9.20504 17.4832 9.57509C17.8887 9.94513 18.1411 10.4534 18.191 11H21.5998C21.7518 11 21.8982 11.0578 22.0092 11.1616C22.1203 11.2654 22.1879 11.4074 22.1982 11.5591C22.2086 11.7108 22.161 11.8607 22.0651 11.9786C21.9691 12.0966 21.832 12.1737 21.6814 12.1944L21.5998 12.2H21.1334L20.1198 20.984C20.0747 21.3739 19.8878 21.7336 19.5947 21.9947C19.3016 22.2558 18.9227 22.4001 18.5302 22.4H13.4694C13.0769 22.4001 12.698 22.2558 12.4049 21.9947C12.1118 21.7336 11.9249 21.3739 11.8798 20.984L10.8654 12.2H10.3998C10.2548 12.2 10.1147 12.1475 10.0055 12.0522C9.89619 11.9569 9.82512 11.8252 9.8054 11.6816L9.7998 11.6C9.79981 11.455 9.85232 11.3149 9.94762 11.2057C10.0429 11.0964 10.1746 11.0253 10.3182 11.0056L10.3998 11H13.8086C13.8585 10.4534 14.1109 9.94513 14.5164 9.57509C14.9218 9.20504 15.4509 8.99992 15.9998 9ZM14.7998 14C14.6038 14 14.4398 14.124 14.4062 14.2872L14.3998 14.3504V19.2504L14.4062 19.3128C14.4398 19.476 14.6038 19.6 14.7998 19.6C14.9958 19.6 15.1598 19.476 15.1934 19.3128L15.1998 19.2496V14.3512L15.1934 14.2872C15.1598 14.1248 14.9958 14 14.7998 14ZM17.1998 14C17.0038 14 16.8398 14.124 16.8062 14.2872L16.7998 14.3504V19.2504L16.8062 19.3128C16.8398 19.476 17.0038 19.6 17.1998 19.6C17.3958 19.6 17.5598 19.476 17.5934 19.3128L17.5998 19.2496V14.3512L17.5934 14.2872C17.5598 14.1248 17.3958 14 17.1998 14ZM15.9998 10.2C15.5158 10.2 15.1118 10.544 15.0198 11H16.9798C16.887 10.544 16.4838 10.2 15.9998 10.2Z" fill="#ADADAD" />
                                        </svg>}

                                </Tooltip> */}
                                <Tooltip
                                    title={<div ref={tooltipRef}> {/* Wrap the content inside ref */}
                                        <h5 className='font-semibold text-base'>{t('Confirm Deletion')}</h5>
                                        <p className='mb-0 text-gray-dark'>{t('Confirm Deletion file Text')}</p>
                                        <hr className='border-b border-solid border-[#ECECEC]'></hr>
                                        <div className='flex gap-1'>
                                            <Button onClick={() => setOpenConfirmDelete(false)} type='primary' size='small' ghost className='w-36 h-8' htmlType='button'>{t('Cancel')}</Button>
                                            <Button onClick={() => handleDelete(record.documentId)} type='primary' size='small' className='w-36 h-8 bg-[#F0536F] border-[#F0536F] text-white hover:bg-[#F0536F] hover:border-[#F0536F] hover:text-white' htmlType='button'>{t('Confirm')}</Button>
                                        </div>
                                    </div>}
                                    placement="left"
                                    color="white"
                                    key={record.documentId}
                                    open={openConfirmDelete && docId === record.documentId}
                                >
                                    <svg
                                        onClick={() => {
                                            setOpenConfirmDelete(true);
                                            setDocId(record.documentId);
                                        }}
                                        width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="32" height="32" rx="6" fill="#F3F6F9" />
                                        <path d="M15.9998 9C16.5487 8.99992 17.0778 9.20504 17.4832 9.57509C17.8887 9.94513 18.1411 10.4534 18.191 11H21.5998C21.7518 11 21.8982 11.0578 22.0092 11.1616C22.1203 11.2654 22.1879 11.4074 22.1982 11.5591C22.2086 11.7108 22.161 11.8607 22.0651 11.9786C21.9691 12.0966 21.832 12.1737 21.6814 12.1944L21.5998 12.2H21.1334L20.1198 20.984C20.0747 21.3739 19.8878 21.7336 19.5947 21.9947C19.3016 22.2558 18.9227 22.4001 18.5302 22.4H13.4694C13.0769 22.4001 12.698 22.2558 12.4049 21.9947C12.1118 21.7336 11.9249 21.3739 11.8798 20.984L10.8654 12.2H10.3998C10.2548 12.2 10.1147 12.1475 10.0055 12.0522C9.89619 11.9569 9.82512 11.8252 9.8054 11.6816L9.7998 11.6C9.79981 11.455 9.85232 11.3149 9.94762 11.2057C10.0429 11.0964 10.1746 11.0253 10.3182 11.0056L10.3998 11H13.8086C13.8585 10.4534 14.1109 9.94513 14.5164 9.57509C14.9218 9.20504 15.4509 8.99992 15.9998 9Z" fill="#7B67FB" />
                                    </svg>
                                </Tooltip>
                            </Tooltip>
                        </>
                    }

                </span>

            ),
        },
    ].filter((item) => !item.hidden);

    const props = {
        name: 'file',
        customRequest: async ({ file, onSuccess, onError }) => {
            setUploading(true);
            let ImageData = new FormData();
            ImageData.append('image', file);
            ImageData.append('fileName', file.name);
            ImageData.append('action', 'image-create-application');

            try {
                const { data } = await GlobalService.uploadPublicImage(ImageData);
                if (data?.resultData?.imageId) {
                    const payload = {
                        fileStorageId: data.resultData.imageId,
                        fileName: file.name,
                        txnDataBreachId: details,
                    };
                    DataBreachService.uploadDocument(payload)
                        .then((res) => {
                            if (res.data.resultMsg === 'SUCCESS') {
                                notify({
                                    title: t('Success'),
                                    description: t('Upload data'),
                                    timeOut: 1800,
                                });
                                getDocumentList(currentPage);
                            }
                        })
                        .catch((err) => {
                            notify({
                                type: 'error',
                                title: t('Fail'),
                                description: t('FailedtoSubmitData'),
                                closeable: true,
                                timeOut: 120000,
                            });
                        });
                    // onSuccess(item); 
                } else {
                    throw new Error('Upload failed. Image ID is missing.');
                }
            } catch (error) {
                // onError(error); 
                console.error(error);
            } finally {
                setUploading(false); // Stop loading
            }
        },
        onChange(info) {
            if (info.file.status !== 'uploading') {
                console.log('Uploading:', info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                console.log('Upload complete:', info.file.response);
            }
            if (info.file.status === 'error') {
                console.log('Upload failed:', info.file.error);
            }
        },
    };

    return (
        <>
            <div>
                <h5 className='text-base font-semibold'>{t('Attachments')}</h5>
                {permission.viewEdit && status !== 'New' && status !== 'Resolved' && status !== 'Reject' &&
                    <Upload {...props} showUploadList={false} >
                        <Button
                            loading={uploading}
                            icon={<UploadOutlined />}
                            size="large"
                            variant="outlined"
                            className='text-purple-PHX border-purple-PHX mt-4'
                            disabled={status === 'New'}
                        >
                            {t('Upload')}
                        </Button>
                    </Upload>
                }

                {(documentData) && <Table
                    locale={{ emptyText: <IconNotFound /> }}
                    className="inbox_table pt-4"
                    rowKey={(record, i) => record.id + i}
                    columns={columns}
                    dataSource={documentData}
                />}
            </div>

        </>
    );
}
